export enum RefundType {
  CASH_REF = "ref11111-1111-1111-1111-111111111111",
  ITEM_EXCHANGE = "ref22222-2222-2222-2222-222222222222",
  STORE_CREDIT = "ref33333-3333-3333-3333-333333333333",
}

export const RefundTypeInfo = {
  [RefundType.CASH_REF]: { code: "cash_ref", name: "Cash Refund" },
  [RefundType.ITEM_EXCHANGE]: { code: "item_exchange", name: "Item Exchange" },
  [RefundType.STORE_CREDIT]: { code: "store_credit", name: "Store Credit" },
} as const;

export const getRefundTypeCode = (value: RefundType): string =>
  RefundTypeInfo[value].code;
export const getRefundTypeName = (value: RefundType): string =>
  RefundTypeInfo[value].name;
